<template>
    <div>
        <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
            <app-sidebar></app-sidebar>
            <div id="page-content-wrapper" style="width:100%">
                <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
                <app-navbar></app-navbar>
                <div class="container-fluid mt-5" id="grad1">
                    <!-- breadcrumb and title row starts -->
                    <div class="row">
                        <div class="col-sm-12">
                            <vs-breadcrumb align="left" :items="[
                          { title: 'You are here : ' },
                          {
                            title: 'Dashboard',
                            url: '/#/dashboard/Admin/adminDashboard'
                          },
                          {
                            title: 'Event Wizard',
    
                          },
                          {
                            title: ` ${trainingData.title} ${formatDateRange(trainingData.startdate, trainingData.enddate)}`,
                            active: true,
                          }
                        ]"></vs-breadcrumb>
                        </div>
                        <div class="col-sm-12">
                            <div class="heading mt-3">
                                <h3 class="text-secondary">Event Wizard</h3>
                            </div>
                        </div>
                    </div>
                    <!-- breadcrumb and title row Ends -->
                    <div class="row justify-content-center mt-0">
                        <div class="col-11 text-center p-0 mt-3 mb-2">
                            <div class="card px-0 pb-0 mt-3 mb-3">
                                <!-- <h2>
                                <strong>Sign Up Your User Account</strong>
                            </h2>
                        <p>Fill all form field to go to next step</p>-->
                                <div class="row">
                                    <div class="col-md-12 mx-0">
                                        <form id="msform">
                                            <!-- progressbar -->
                                            <ul id="progressbar">
                                                <li @click="trainingAssignment()" class="completed" id="NewTraining">
                                                    <strong>Event Assignment</strong>
                                                </li>
                                                <li @click="showPage2()" :class="{ 'active' : active == 2 }" id="PoAssignment">
                                                    <strong>P.O Assignment</strong>
                                                </li>
                                                <li @click="trainingInformation()" :class="{ 'active' : active == 3 }" id="TrainingInformation">
                                                    <strong>Event Information</strong>
                                                </li>
                                                <li @click="trainerRegistration()" :class="{ 'active' : active == 4 }" id="TrainerRegistration">
                                                    <strong>Facilitators' Registration</strong>
                                                </li>
                                                <li @click="trainingAgenda()" :class="{ 'active' : active == 5 }" id="TrainingAgenda">
                                                    <strong>Event Agenda</strong>
                                                </li>
                                                <li @click="uploadMaterial()" :class="{ 'active' : active == 6 }" id="Trainingmaterial">
                                                    <strong>Upload Material</strong>
                                                </li>
                                                <li @click="assessmentFunction()" :class="{ 'active' : active == 7 }" id="TrainingAssessments">
                                                    <strong>Assessments</strong>
                                                </li>
    
                                                <li @click="traineeRegFunction()" :class="{ 'active' : active == 8 }" id="TraineeRegistration">
                                                    <strong>Participants' Registration</strong>
                                                </li>
                                                <li @click="assessmentReviewFunction()" :class="{ 'active' : active == 9 }" id="AssessmentReview">
                                                    <strong>Review</strong>
                                                </li>
                                                <li @click="trainingCompletionFunction()" :class="{ 'active' : active == 10 }" id="Completion">
                                                    <strong>Completion</strong>
                                                </li>
                                            </ul>
                                            <!-- fieldsets -->
                                            <fieldset v-if="adminPage2 == true" style="text-align: left;padding: 30px;">
                                                <h5>Event Assignment</h5>
                                                <!-- row 1 starts  -->
                                                <div class="row mt-5">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Event Title</label>
                                                            <input style="opacity: 1 !important;background-color: #d3d3d3;" type="text" class="form-control form-control-sm" placeholder="Terrorism Investigation Course" :value="getTrainingData.title || ''" disabled id="first" />
                                                        </div>
                                                    </div>
    
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Project</label>
                                                            <select style="opacity: 1 !important;background-color: #d3d3d3;" class="form-control form-control-sm" id="exampleFormControlSelect1" disabled>
                                                                <option selected>
                                                                    {{ getProjectData.title || '' }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- row 1 ends -->
                                                <!-- row 2 starts  -->
                                                <div class="row mt-2">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Sub Programme</label>
                                                            <select style="opacity: 1 !important;background-color: #d3d3d3;" class="form-control form-control-sm" id="exampleFormControlSelect1" disabled>
                                                                <option selected>
                                                                    {{ getSubprogramData.title || '' }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Assigned Advisor</label>
                                                            <select style="opacity: 1 !important;background-color: #d3d3d3;" class="form-control form-control-sm" id="exampleFormControlSelect1" disabled>
                                                                <option selected>
                                                                    {{ getAdvisorData.name }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- row 2 ends -->
                                                <!-- row 3 starts  -->
                                                <div class="row mt-2">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">Select Program Officer</label>
                                                        <selectize id="select-state" v-model="officerSelected" :searchable="true" disabled>
                                                            <option v-for="(item, index) in programOfficerAssign" :key="index" :value="item.id">
                                                                {{ item.name }}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label style="padding-left: 5px;font-size:.85rem;">Donor Name</label>
                                                        <selectize id="select-state" v-model="fundingAgencySelected" :settings="donersettings" disabled>
                                                            <option v-for="(item, index) in donernameArr" :key="index" :value="item.id">
                                                                {{ item.title || ''}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">
                                                            Thematic Area
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                        <selectize id="select-state" v-model="thematicareaSelectedUpdate" :settings="thematicareasettings" disabled>
                                                            <option v-for="(item, index) in valuesArray" :key="index" :value="item.id">
                                                                {{ item.name }}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">
                                                            Select Date Range
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                        <flat-pickr class="form-control" style="background: #fff" placeholder="Start date Range *" v-model="dateRange" :config="dateOptions" disabled></flat-pickr>
                                                    </div>
                                                </div>
                                                <!-- <div class="row">
                                                        <div class="col-md-6">
                                                            <label style="font-weight:700;" for="first">Relevant Project Outcome</label>
                                                            <input type="text" class="form-control form-control-sm" v-model="outcome" id="outcome" />
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label style="font-weight:700;" for="first">Relevant Project Output</label>
                                                            <input type="text" class="form-control form-control-sm" v-model="output" id="output" />
                                                        </div>
                                                    </div> -->
                                                <div class="row mt-2">
                                                    <div class="col-sm-6">
                                                        <div class="floating-label">
                                                            <label style="font-weight:700;" for="first">
                                                                No of days
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                            <input disabled class="floating-input form-control" v-model="noOfDays" type="text" placeholder=" " />
    
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;">event</i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- row 3 ends  -->
    
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <router-link to="/dashboard/admin/trainingWizard" class="btn btn-primary btn-sm m-1 pt-2">
                                                            Back
                                                        </router-link>
                                                        <button type="button" v-on:click="trainingInformation()" class="btn btn-primary btn-sm m-1">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
    
                                                <!-- Next Step Button Ends  -->
                                            </fieldset>
                                            <fieldset v-if="adminPage3 == true" style="text-align: left;padding: 30px;">
                                                <h5>Event Information</h5>
                                                <!-- row 1 starts  -->
                                                <div class="row mt-4">
                                                    <!--  col-md-6   -->
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Event Title</label>
                                                            <input style="opacity: 1 !important;background-color: #d3d3d3;" type="text" class="form-control form-control-sm" placeholder="Terrorism Investigation Course" disabled id="first" :value="getTrainingData.title || ''" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Sub Program</label>
                                                            <input style="opacity: 1 !important;background-color: #d3d3d3;" type="text" class="form-control form-control-sm" placeholder="Terrorism Investigation Course" disabled id="first" :value="getSubprogramData.title || ''" />
                                                        </div>
                                                    </div>
                                                    <!--  col-md-6   -->
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Project</label>
                                                            <select style="opacity: 1 !important;background-color: #d3d3d3;" class="form-control form-control-sm" id="exampleFormControlSelect1" disabled>
                                                                <option :value="getTrainingData.project.id" selected>
                                                                    {{getProjectData.title || ''}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Donor Name</label>
                                                            <selectize id="select-state" disabled v-model="donerSelected" :settings="donersettings">
                                                                <option v-for="(item,index) in selectedDoner" :key="index" :value="item.id" disabled>
                                                                    {{item.title || ''}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="row mt-2">
    
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Department</label>
                                                            <selectize id="select-state" v-model="department" :settings="departmentsettings" disabled>
                                                                <option v-for="(item,index) in departmentArr" :key="index" :value="item.id">
                                                                    {{item.title || ''}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Type</label>
                                                            <selectize v-model="type_training" disabled>
                                                                <!-- settings is optional -->
                                                                <option v-for="(tType,index) in trainingTypeArr" :key="index" :value="tType.id">
                                                                    {{tType.title || ''}}
                                                                </option>
                                                            </selectize>
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="row mt-2">
    
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Date Range</label>
                                                            <flat-pickr class="form-control" style="background: #fff" placeholder="Start date Range" v-model="dateRange" :config="dateOptions" disabled></flat-pickr>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="">
                                                            <label style="font-weight:700;" for="first">Days</label>
                                                            <input class="floating-input form-control" v-model="noOfDays" type="text" disabled placeholder=" " />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">Relevant Project Outcome</label>
                                                        <input type="text" disabled class="form-control form-control-sm" v-model="outcome" id="outcome" />
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">Relevant Project Output</label>
                                                        <input type="text" disabled class="form-control form-control-sm" v-model="output" id="output" />
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">Location</label>
                                                        <selectize id="select-state" v-model="district" disabled>
                                                            <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                                {{item.title || ''}}, {{item.province.title || ''}},
                                                                {{item.province.country.title || ''}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label style="font-weight:700;" for="first">
                                                            Contact Person
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                        <input class="floating-input form-control" v-model="contact_person" type="text" placeholder=" " disabled />
                                                    </div>
                                                </div>
    
                                                <div class="row mt-2">
                                                    <div class="col-md-6 col-lg-6" style="margin-top:10px;">
                                                        <div class="floating-label">
                                                            <input class="floating-input form-control" v-model="contact_number" type="text" v-mask="'(9999) 9999999'" placeholder=" " disabled />
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;">call</i>
                                                            </span>
                                                            <label class="lbl-label">
                                                                Contact Number
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
    
                                                    <div class="col-md-6" style="margin-top:10px;">
                                                        <div class="floating-label">
                                                            <input class="floating-input form-control" v-model="contact_email" type="email" placeholder=" " disabled />
    
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;">email</i>
                                                            </span>
                                                            <label class="lbl-label">
                                                                Email
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="row mt-2">
                                                    <!-- floating input starts -->
                                                    <div class="col-md-6" style="margin-top:10px;">
                                                        <div class="floating-label">
                                                            <input class="floating-input form-control" v-model="address" type="text" placeholder=" " disabled />
    
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;">place</i>
                                                            </span>
                                                            <label class="lbl-label">
                                                                Address
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <!-- floating input ends -->
                                                    <!-- Address Ends -->
                                                    <!-- floating input starts -->
                                                    <div class="col-md-12 col-lg-12" style="margin-top:10px;">
                                                        <div class="floating-label">
                                                            <input class="floating-input form-control" v-model="venue" type="text" placeholder=" " disabled />
    
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;">account_balance</i>
                                                            </span>
                                                            <label class="lbl-label">
                                                                Venue
                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="showPage2()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="trainerRegistration()" class="btn btn-primary btn-sm m-1">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
    
                                                <!-- Next Step Button Ends  -->
                                            </fieldset>
                                            <div v-if="adminPage4 == true">
                                                <TrainerView />
    
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="trainingInformation()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="trainingAgenda()" class="btn btn-primary btn-sm">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
    
                                                <!-- Next Step Button Ends  -->
                                            </div>
                                            <div v-if="adminPage5 == true">
                                                <TrainingAgenda />
    
                                                <!-- row 1 starts  -->
                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-12 text-right">
                                                            <button type="button" v-on:click="trainerRegistration()" class="btn btn-primary btn-sm m-1">
                                                                Back
                                                            </button>
                                                            <button type="button" v-on:click="uploadMaterial()" class="btn btn-primary btn-sm">
                                                                Next
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <!-- Next Step Button Ends  -->
                                            </div>
                                            <div v-if="adminPage6 == true">
                                                <UploadMaterial />
    
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="trainingAgenda()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="assessmentFunction()" class="btn btn-primary btn-sm">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                                <!-- Next Step Button Ends  -->
                                            </div>
                                            <div v-if="adminPage7 == true">
                                                <TrainingAssessment />
    
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="uploadMaterial()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="traineeRegFunction()" class="btn btn-primary btn-sm">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div v-if="adminPage8 == true">
                                                <TraineeRegistration />
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="assessmentFunction()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="assessmentReviewFunction()" class="btn btn-primary btn-sm">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
    
                                                <!-- Next Step Button Ends  -->
                                            </div>
                                            <div v-if="adminPage9 == true">
                                                <AssessmentReview />
                                                <!-- Next Step Button Starts  -->
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button type="button" v-on:click="traineeRegFunction()" class="btn btn-primary btn-sm m-1">
                                                            Back
                                                        </button>
                                                        <button type="button" v-on:click="trainingCompletionFunction()" class="btn btn-primary btn-sm">
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                                <!-- Next Step Button Ends  -->
                                            </div>
                                            <div v-if="adminPage10 == true">
                                            <fieldset  style="text-align: left;padding: 30px; min-height: 300px">
                                                <span v-if="this.trainingType != 1">
                                                    <h5 class="text-center text-success mt-5">
                                                        <i class="material-icons">check</i> This Event
                                                        has been setup successfully!
                                                    </h5>
                                                </span>
                                                <span v-else-if="this.training_status.preassesment_status == 1 && this.training_status.postassesment_status == 1">
                                                    <h5 class="text-center text-success mt-5">
                                                        <i class="material-icons">check</i> This training
                                                        has been setup successfully!
                                                    </h5>
                                                </span>
                                                <span class="mt-3" v-else>
                                                    <h5 class="text-center text-danger">
                                                        This Training is not completed and still In-Progress
                                                    </h5>
                                                    <hr />
                                                    <li class="text-success" v-if="this.training_status.preassesment_status == 1">
                                                        <i class="material-icons">check</i> Pre Assessment
                                                        is enabled and being completed.
                                                    </li>
                                                    <li v-else class="text-danger">
                                                        <i class="material-icons">close</i> Pre Assessment
                                                        is not enabled yet.
                                                    </li>
                                                    <li class="text-success" v-if="this.training_status.postassesment_status == 1">
                                                        <i class="material-icons">check</i> Post Assessment
                                                        is enabled and being completed.
                                                    </li>
                                                    <li v-else class="text-danger">
                                                        <i class="material-icons">close</i> Post Assessment
                                                        is not enabled yet.
                                                    </li>
                                                    <li class="text-success" v-if="this.training_status.feedbackstatus == 1">
                                                        <i class="material-icons">check</i> Feedback is
                                                        enabled and being completed.
                                                    </li>
                                                    <li v-else class="text-danger">
                                                        <i class="material-icons">close</i> Feedback is not
                                                        enabled yet.
                                                    </li>
                                                    <hr />
                                                </span>
                                                <!-- row 1 starts  -->
                                                <div class="row mt-5 mb-1 d-flex justify-content-center">
                                                    <button class="btn btn-primary float-right ml-3">
                                                        <router-link :to="{
                                      path:
                                        '/dashboard/admin/brief_training_report',
                                      query: { trainingId: this.trainingCode }
                                    }" class="white-text">Brief Event Details
                                                        </router-link>
                                                    </button>
    
                                                    <button class="btn btn-primary float-right ml-3">
                                                        <router-link :to="{
                                        path:
                                          '/dashboard/admin/analysis-report',
                                        query: { trainingId: this.trainingCode }
                                      }" class="white-text">Overall Event Analysis</router-link>
                                                    </button>
    
                                                    <button class="btn btn-primary float-right ml-3">
                                                        <router-link :to="{
                                        path:
                                          '/dashboard/admin/individual_analysis_report',
                                        query: { trainingId: this.trainingCode }
                                      }" class="white-text">Individual Event Analysis</router-link>
                                                    </button>
                                                    <button class="btn btn-primary float-right ml-3">
                                                        <div @click="getReport">
                                                            Download Event Report
                                                        </div>
                                                    </button>
                                                </div>
    
                                                <div class="row d-flex justify-content-center mt-4">
                                                    <button class="btn btn-info" @click="downloadReferences">
                                                        Download References
                                                        <i class="material-icons" style="font-size: 20px;">print</i>
                                                    </button>
                                                    <button class="btn btn-info float-right ml-5" @click="downloadSheet">
                                                        Attendance Sheet
                                                        <i class="material-icons" style="font-size: 20px;">file_download</i>
                                                    </button>
                                                    <button class="btn btn-info float-right ml-5" @click="printSheet">
                                                        Attendance Sheet
                                                        <i class="material-icons" style="font-size: 20px;">print</i>
                                                    </button>
                                                </div>
                                                <!-- row 1 ends -->
                                                 
                                                <div class="row d-flex justify-content-center mt-4">
                                                   
                                                    <button class="btn btn-primary float-right ml-3">
                                                        <router-link :to="{
                                                                path:'/dashboard/Admin/feedBackTrainer',
                                                                query: { trainingId: this.trainingCode }
                                                                    }" 
                                                                class="white-text">Facilitators Feedback 
                                                        </router-link>
                                                    </button>
                                                    
                                                    <button class="btn btn-primary float-right ml-3" @click="openNominationModal" v-if="this.nominationFiles.length > 0">
                                                        Nomination Letter
                                                        <span v-if="nominationFiles.length > 0" class="badge badge-light ml-1">{{ nominationFiles.length }}</span>
                                                        <i class="material-icons" style="font-size: 20px;">visibility</i>
                                                    </button>
                                                   
                                                    
                                                </div>
    
                                            </fieldset>
        <div class="container-fluid">
                    <div class="row justify-content-md-center">
                      
                                   <!-- Left: Table -->
                      <div class="col-md-12 mb-4">
                        <b-card title="Uploaded Attendance Sheet" class="h-100" v-if="attendanceSheetUrl">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>File</th>
                    <th>File Type</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img
                        :src="getFileIcon(this.attendanceSheetUrl)"
                        alt="File Icon"
                        width="50"
                        height="50"
                        style="object-fit: cover; border-radius: 5px;"
                      />
                    </td>
                    <td>{{ getFileType(this.attendanceSheetUrl) }}</td>
                    <td class="text-center download-cell" @click="downloadFile()">
                         <button class="download-btn">
                           <i class="material-icons">cloud_download</i>
                           <span class="download-text">Download</span>
                         </button>
                </td>
                  </tr>
                </tbody>
              </table>
            </div>
                      </b-card>
                    </div>
    
       
            </div>
        </div>
       
      
          </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <template >
                        <div>
                            <div id="attendance-sheet" >
                                <div>
                                    <img :src="Logo" alt="UNODC Logo" style="width: 200px;" />
                                </div>
                                <div>
                                    <p class="address">
                                        G-5, Islamabad, Phone: (051) 2601461 <br />UNODC COAPK, Plot#
                                        5, Diplomatic Enclave
                                    </p>
                                </div>
    
                                <div class="header">
                                    <h3>Event Attendance Sheet</h3>
                                </div>
    
                                <table>
                                    <tr>
                                        <th colspan="4" style="text-align: left;">
                                            Event Title:
                                            {{trainingResponse.title || ''}}
                                        </th>
                                        <th colspan="3" style="text-align: left;">
                                            Event Dates:
                                            {{trainingResponse.startdate ? formattedDate(trainingResponse.startdate) : ''}}
                                            to
                                            {{trainingResponse.enddate ? formattedDate(trainingResponse.enddate) : ''}}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th colspan="4" style="text-align: left;">
                                            Event Venue: {{trainingResponse.venue || ''}}
                                        </th>
                                        <th colspan="3" style="text-align: left;">
                                            Total No. of Participants: (___________)
                                        </th>
                                    </tr>
                                </table>
                                <br />
                                <table>
                                    <tr>
                                        <th colspan="5" class="list_name">Participants</th>
                                        <th :colspan="trainingResponse.noofdays">
                                            Signature
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>S#</th>
                                        <th>Name</th>
                                        <th>Organization</th>
                                        <th>Designation</th>
                                        <th>Mobile No</th>
                                        <!-- <th>Email</th> -->
                                        <th v-for="day in Number(trainingResponse.noofdays)" :key="'day-' + day">
                                            Day-{{ day }}
                                        </th>
                                    </tr>
                                    <tr v-for="(user, index) in itemsTrainee" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{
                                               user.gender === 'male' ? 'Mr.' :
                                               user.gender === 'female' ? 'Ms.' :
                                               user.gender === 'rather not say' ? 'Mx' :
                                               ''
                                             }}
                                            {{ user.name || ' '}}</td>
                                        <td>{{ user.department ||  ' '}}</td>
                                        <td>{{ user.designation || ' '}}</td>
                                        <td>{{user.contactNo }}</td>
                                        <!-- <td>{{user.email }}</td> -->
                                        <td v-for="day in Number(trainingResponse.noofdays)" :key="'user-day-' + index + '-' + day"></td>
                                    </tr>
                                    <tr v-for="emptyIndex in 10" :key="'empty-' + emptyIndex">
                                        <td>
                                            {{ itemsTrainee.length + emptyIndex }}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td v-for="day in Number(trainingResponse.noofdays)" :key="'empty-day-' + emptyIndex + '-' + day"></td>
                                    </tr>
                                </table>
                                <br />
                                <table>
                                    <tr>
                                        <th colspan="5" class="list_name">UNODC Staff</th>
                                        <th :colspan="trainingResponse.noofdays">
                                            Signature
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>S#</th>
                                        <th>Name</th>
                                        <th>Department</th>
                                        <th>Designation</th>
                                        <th>Mobile No</th>
                                        <th v-for="day in Number(trainingResponse.noofdays)" :key="'day-' + day">
                                            Day-{{ day }}
                                        </th>
                                    </tr>
                                    <tr v-for="(user, index) in itemsTrainer" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{
                                               user.gender === 'male' ? 'Mr.' :
                                               user.gender === 'female' ? 'Ms.' :
                                               user.gender === 'rather not say' ? 'Mx' :
                                               ''
                                             }} {{ user.trainer?.name || ' '}}</td>
                                        <td>{{ user.trainer?.trainer_user_id?.departments?.title || ' '}}</td>
                                        <td>
                                            {{ user.trainer?.designations?.title || ' '}}
                                            <!-- {{getDesignationTitle(user.trainer.designation? user.trainer.designation.id : null)}} -->
                                        </td>
                                        <td>{{user.contactNo }}</td>
                                        <td v-for="day in Number(trainingResponse.noofdays)" :key="'empty-day-' + emptyIndex + '-' + day"></td>
                                    </tr>
                                    <tr v-for="emptyIndex in 2" :key="'empty-' + emptyIndex">
                                        <td>
                                            {{ itemsTrainer.length + emptyIndex }}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td v-for="day in Number(trainingResponse.noofdays)" :key="'empty-day-' + emptyIndex + '-' + day"></td>
                                    </tr>
                                </table>
                                <br />
                                <table>
                                    <tr>
                                        <th colspan="5" class="list_name">Supporting Staff</th>
                                        <th :colspan="trainingResponse.noofdays">
                                            Signature
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>S#</th>
                                        <th>Name</th>
                                        <th>Organization</th>
                                        <th>Designation</th>
                                        <th>Mobile No</th>
                                        <th v-for="day in Number(trainingResponse.noofdays)" :key="'day-' + day">
                                            Day-{{ day }}
                                        </th>
                                    </tr>
    
                                    <tr v-for="emptyIndex in 3" :key="'empty-' + emptyIndex">
                                        <td>
                                            {{ emptyIndex }}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td v-for="day in Number(trainingResponse.noofdays)" :key="'empty-day-' + emptyIndex + '-' + day"></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- Nomination Modal -->
    <div class="modal2" v-if="showNominationModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Nomination Letters</h4>
                    <button type="button" class="close" @click="closeNominationModal">&times;</button>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                    <!-- Files List -->
                    <div v-if="nominationFiles && nominationFiles.length > 0">
                        <h6 style="font-weight: 700; margin-bottom: 15px;">Available Files:</h6>
                        <div class="uploaded-files-list">
                            <div v-for="(file, index) in nominationFiles" :key="index" class="file-item d-flex align-items-center justify-content-between mb-2 p-2" style="border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;">
                                <div class="file-info d-flex align-items-center" style="flex: 1;">
                                    <i class="material-icons mr-2" style="font-size: 20px; color: #007bff;">description</i>
                                    <span style="font-size: 14px; color: #333; word-break: break-all;">{{ file.split('/').pop() }}</span>
                                </div>
                                <button type="button" @click="downloadNomination(file)" class="btn btn-success btn-sm ml-2" style="min-width: 90px;">
                                    <i class="material-icons" style="font-size: 16px; vertical-align: middle;">file_download</i>
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-center text-muted">No nomination letters available.</p>
                    </div>
                </div>
                <!-- Modal Footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeNominationModal">Close</button>
                </div>
            </div>
        </div>
        </div>
    </div>
    </template>
    
        
    <script>
    import Navbar from "./Navbar";
    import Sidebar from "./Sidebar";
    import Selectize from "vue2-selectize";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import axios from "axios";
    import {formatDateRange} from "../../../utils/DateFormate";
    import {
        downloadTrainingReport
    } from '../../../utils/DownloadReport';
    import {
        downloadReference
    } from '../../../utils/ReferenceReport';
    import TrainerView from './TrainingEdit/trainerRegistration';
    import TrainingAgenda from './TrainingEdit/trainingAgenda';
    import UploadMaterial from './TrainingEdit/uploadMaterial';
    import TrainingAssessment from './TrainingEdit/trainingAssessment';
    import TraineeRegistration from './TrainingEdit/traineeRegistration';
    import AssessmentReview from './TrainingEdit/assessmentReview'
    import html2pdf from "html2pdf.js";
    
    export default {
        data: () => ({
            BASEPATHDYNAMIC: process.env.VUE_APP_BASE_PATH,
            attendanceData: [],
            outcome: "",
            output: "",
            trainingData: [],
            isSidebar: false,
            trainingId: "",
            trainingCode: "",
            updateTraining: [],
            officerSelected: "",
            update_training_id: "",
            dateRange: [],
            dateOptions: {
                wrap: true,
                weekNumbers: true,
                mode: "range",
                maxDate: new Date().fp_incr(9),
                dateFormat: "d-m-Y"
            },
            fundingAgencySelected: [],
            donersettings: {
                maxItems: 5,
                plugins: ["remove_button"],
                delimiter: "|"
            },
            donernameArr: [],
            thematicareaSelectedUpdate: [],
            thematicareasettings: {
                maxItems: 10,
                plugins: ["remove_button"],
                delimiter: "|"
            },
            startdate: "",
            startDate: "",
            endDate: "",
            programOfficerAssign: [],
            project: "",
            advisor: "",
            subprogram: "",
            enddate: "",
            valuesArray: [],
            noOfDays: "",
            isDataEdit: 0,
            active: 2,
            type_training: "",
            country: "",
            province: "",
            district: "",
            department: [],
            departmentsettings: {
                maxItems: 10,
                plugins: ["remove_button"],
                delimiter: "|"
            },
            // project_title: 1,
            trainingtitleArr: [],
            projecttitleArr: [],
            cityArr: [],
            createdTrainingss: "",
            trainingTypeArr: [],
            countryArr: [],
            provinceArr: [],
            contact_number: "",
            contact_email: "",
            contact_person: "",
            departmentArr: [],
            address: "",
            options: {
                format: "DD/MM/YYYY",
                useCurrent: false
            },
            textarea: "",
            venue: "",
            donerSelected: [],
            selectedDoner: [],
            newTrainer: [],
            foundAgenda: [],
            materialRecords: [],
    
            // pre & post assessments
            existPreassessmentForm: false,
            showAssessmentTable: false,
            easyPercent: 0,
            mediumPercent: 0,
            hardPercent: 0,
            assessmentShowArr: [],
            // End of pre & post
            // Starts of Trainer feedback
            existTrainerFeedbackForm: false,
            trainerFeedbackShowArr: [],
            // End of Trainer feedback
    
            // Trainee
            traineeFeedbackShowArr: [],
            existTraineeFeedForm: false,
            // End of Trainee
            itemsTrainee: [],
            itemsTrainer: [],
            itemsTraineeReview: [],
            training_status: "",
            adminPage2: true,
            adminPage3: false,
            adminPage4: false,
            adminPage5: false,
            adminPage6: false,
            adminPage7: false,
            adminPage8: false,
            adminPage9: false,
            adminPage10: false,
            designationArr: [],
            trainingType: '',
            Logo: require('@/assets/unodc_logo.png'),
            trainingResponse:{},
            attendanceSheetUrl:'',
            BASEPATHDYNAMIC:'',
            nominationLetter:null,
            showNominationModal: false,
            nominationFiles: [],
            
        }),
        created() {
            this.trainingCode = this.$route.query.trainingId;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/advisor/" +
                    this.$route.query.trainingId +
                    "/edit"
    
                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
    
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.trainingId = response.data.training.id;
                        this.nominationLetter = response.data?.training?.training_nominations;
                        this.attendanceSheetUrl = response.data.training.attendance_sheet;
                        this.training_status = response.data.training;
                        this.thematicareaSelectedUpdate = [];
                        this.fundingAgencySelected = [];
                        this.officerSelected = [];
                        try {
                const nominationData = response.data?.training?.training_nomination;
                    if (nominationData && nominationData.trim() !== '') {
                        // Split by comma and trim each URL
                        this.nominationFiles = nominationData.split(',').map(url => url.trim()).filter(url => url);
                    } else {
                        this.nominationFiles = [];
                    }
                } catch (e) {
                    console.error('Error parsing nomination files:', e);
                    this.nominationFiles = [];
                }
                        // this.freqUpdateArr =[];
                        if (response.data && response.data.thematic != "") {
                            response.data.thematic.forEach(dnr => {
                                this.thematicareaSelectedUpdate.push(dnr.id);
                            });
                        }
                        if (response.data && response.data.fundingagency != "") {
                            response.data.fundingagency.forEach(dnr => {
                                this.fundingAgencySelected.push(dnr.id);
                            });
                        }
                        response.data.officer.forEach(dnr => {
                            this.officerSelected.push(dnr.id);
                        });
                        if (
                            response.data.training != "" &&
                            response.data.training.TrainingDates != undefined &&
                            response.data.training.TrainingDates != ""
                        ) {
                            JSON.parse(response.data.training.TrainingDates).forEach(
                                element => {
                                    if (
                                        element.startDate != undefined &&
                                        element.endDate != undefined &&
                                        element.endDate != "" &&
                                        element.startDate != ""
                                    ) {
                                        this.freqUpdateArr.push({
                                            startDate: element.startDate,
                                            endDate: element.endDate
                                        });
                                    }
                                }
                            );
                        }
    
                        this.noOfDays = response.data?.training?.noofdays;
                        this.freqLimit = response.data?.training?.frequency;
                    }
                });
        },
        mounted() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
            this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
            this.showPage2();
    
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/programofficer/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
    
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.programOfficerAssign = response.data;
                });
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/donernames/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
    
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.donernameArr = response.data;
                });
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/thematics/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
    
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.valuesArray = response.data;
                });
    
            //designation
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
                .then((response) => {
                    this.designationArr = response.data;
                });
    
        },
    
        methods: {
            formatDateRange,
            getFileType(filename) {
                const extension = filename.split('.').pop().toLowerCase();
                if (extension === 'pdf') {
                    return 'PDF';
                } else if (extension === 'doc' || extension === 'docx') {
                    return 'Word';
                } else if (extension === 'ppt' || extension === 'pptx') {
                    return 'PPT';
                } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') {
                    return 'Image';
                }  else {
                    return 'Unknown';
                }
            },
            getFileIcon(fileName) {
                if (!fileName) {
                    return "https://via.placeholder.com/50"; // Placeholder if no file
                }
    
                const ext = fileName.split('.').pop().toLowerCase();
    
                switch (ext) {
                    case "pdf":
                        return "https://cdn-icons-png.flaticon.com/512/337/337946.png"; // PDF icon
                    case "doc":
                    case "docx":
                        return "https://cdn-icons-png.flaticon.com/512/732/732220.png"; // Word icon
                    case "ppt":
                    case "pptx":
                        return "https://cdn-icons-png.flaticon.com/512/888/888880.png"; // PPT icon
                    case "xls":
                    case "xlsx":
                        return "https://cdn-icons-png.flaticon.com/512/732/732227.png"; // Excel icon
                    case "jpg":
                    case "jpeg":
                    case "png":
                    case "gif":
                        return this.BASEPATHDYNAMIC + "/" + fileName; // Show actual image
                    default:
                        return "https://cdn-icons-png.flaticon.com/512/1250/1250595.png"; // Default file icon
                }
            },
            downloadFile() {
              this.openLoading();
              const fullFilePath = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + this.attendanceSheetUrl.replace(/^\//, "");
            
              axios({
                url: fullFilePath,
                method: "GET",
                responseType: "blob",
                headers: {
                  Authorization: localStorage.getItem("token") // if required
                }
              })
                .then(response => {
                  const blob = new Blob([response.data], {
                    type: response.headers["content-type"] || "application/octet-stream"
                  });
            
                  const link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.setAttribute("download", this.getFileName(fullFilePath)); // Fixed here
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  this.closeLoading();
                })
                .catch(() => {
                  this.$toasted.global.errorMsg("Failed to download the file.");
                  this.closeLoading();
                });
            },
            getFileName(path) {
              return path.split("/").pop();
            },
            formattedDate(tdate) {
                if (!tdate) return ''; // Return empty string if date is undefined/null
                try {
                    const [year, month, day] = tdate.split("-");
                    return `${day}-${month}-${year}`;
                } catch (e) {
                    return ''; // Return empty string if splitting fails
                }
            },
            downloadReferences() {
                this.openLoading();
                axios.get(process.env.VUE_APP_BASE_PATH + "/references/download/" + this.trainingId)
                    .then(response => {
                        this.closeLoading();
                        if (response.data.length > 0) {
                            downloadReference(response.data);
                        } else {
                            this.$toasted.global.errorMsg('No references found for this training');
                        }
                    })
                    .catch(() => {
                        this.closeLoading();
                        this.$toasted.global.errorMsg('Error checking references');
                    });
            },
            downloadNomination(fileUrl) {
            this.openLoading();
            const fullFilePath = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + fileUrl.replace(/^\//, "");

            axios({
                    url: fullFilePath,
                    method: "GET",
                    responseType: "blob",
                    headers: {
                        Authorization: localStorage.getItem("token") // if required
                    }
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"] || "application/octet-stream"
                    });

                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", this.getFileName(fullFilePath));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.closeLoading();
                })
                .catch(() => {
                    this.$toasted.global.errorMsg("Failed to download the file.");
                    this.closeLoading();
                });
        },
            // step 1
            trainingAssignment() {
                this.$router.push('/dashboard/admin/trainingWizard');
            },
            // show step 2
            showPage2() {
                this.openLoading();
                this.adminPage2 = true;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 2;
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/advisor/trainingsingle/get/" +
                        this.trainingCode
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        const tId = response.data.training?.id;
                        this.getAttendance(tId);
                        this.trainingType = response.data.training?.typetraining_id,
                        this.trainingData = response.data.training,
                        this.updateTraining = response.data;
                        this.update_training_id = response.data?.id;
                        this.outcome = response.data.training?.outcome?? '';
                        this.output = response.data.training?.output?? '';
                        
                        if (response.data.project != undefined) {
                            this.project = response.data.project?.title;
                        }
                        if (response.data.subprogram) {
                            this.subprogram = response.data.subprogram?.title;
                        }
                        if (response.data.advisor) {
                            this.advisor = response.data.advisor?.name;
                        }
                        this.dateRange =
                            this.updateTraining.training?.startdate + " to " + this.updateTraining?.training?.enddate;
                    });
    
            },
            // step 3
            trainingInformation() {
                this.adminPage2 = false;
                this.adminPage3 = true;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 3;
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/programOfficer/trainingsingle/get/" +
                        this.trainingCode
                    )
                    .then(async response => {
    
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
    
                        await this.adminCountry();
                        await this.adminProvince();
                        await this.adminDistricts();
                        await this.adminDepartment();
                        await this.adminTrainingType();
    
                        if (response.data && response.data.doner != undefined) {
                            this.selectedDoner = response.data.doner;
                        }
                        response.data.doner.forEach(dnr => {
                            this.donerSelected.push(dnr.id);
                        });
                        if (response.data.training.typetraining_id != null) {
                            this.type_training = response.data.training.typetraining_id;
                        }
                        if (
                            response.data?.training != undefined &&
                            response.data?.training != null &&
                            response.data?.training?.noofdays
                        ) {
                            this.noOfDays = response.data?.training?.noofdays;
                        }
                        if (
                            response.data.training.startdate != null &&
                            response.data.training.enddate != null
                        ) {
                            this.dateRange =
                                response.data.training.startdate +
                                " to " +
                                response.data.training.enddate;
                        }
                        if (response.data.training.district_id != null) {
                            this.district = response.data.training.district_id;
                        }
                        if (response.data.training.contact_person != null) {
                            this.contact_person = response.data.training.contact_person;
                        }
                        if (response.data.training.contact_number != null) {
                            this.contact_number = response.data.training.contact_number;
                        }
                        if (response.data.training.email != null) {
                            this.contact_email = response.data.training.email;
                        }
                        if (response.data.training.address != null) {
                            this.address = response.data.training.address;
                        }
                        if (response.data.training.venue != null) {
                            this.venue = response.data.training.venue;
                        }
    
                        if (response.data.departments && response.data.departments != "") {
                            response.data.departments.forEach(department => {
                                this.department.push(department.id);
                            });
                        }
                        // this.type_training = response.data.trainingtype.title;
                    });
            },
            // step 4
            trainerRegistration() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = true;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 4;
                this.newTrainer = [];
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/trainer/show/training/" +
                        this.trainingId
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data != null)
                            this.newTrainer = response.data;
                    });
            },
            // step 5
            trainingAgenda() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = true;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 5;
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/check/traninig/agenda/" +
                        this.trainingId
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data && response.data.foundagenda != null) {
                            this.foundAgenda = response.data.foundagenda;
                        } else {
                            this.foundAgenda = [];
                        }
                    });
            },
            // step 6
            uploadMaterial() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = true;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 6;
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/training_material/get/" + this.trainingId
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.materials) {
                            this.materialRecords = response.data.materials;
                        }
                    });
            },
            // step 7
            assessmentFunction() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = true;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 7;
                this.showAssessment();
                this.showTraineeFeedback();
                this.showTrainerFeedback();
            },
            // step 8
            traineeRegFunction() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = true;
                this.adminPage9 = false;
                this.adminPage10 = false;
                this.active = 8;
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingId
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.itemsTrainee = response.data;
                    });
            },
            // step 9
            assessmentReviewFunction() {
    
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = true;
                this.adminPage10 = false;
                this.active = 9;
    
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingId
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.itemsTraineeReview = response.data;
                    });
            },
    
            // step 10 completion
            trainingCompletionFunction() {
                this.adminPage2 = false;
                this.adminPage3 = false;
                this.adminPage4 = false;
                this.adminPage5 = false;
                this.adminPage6 = false;
                this.adminPage7 = false;
                this.adminPage8 = false;
                this.adminPage9 = false;
                this.adminPage10 = true;
                this.active = 10;
            },
    
            // this will show assessment which has been added
            showAssessment: function showAssessment() {
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/program-officer/training/assessment/" +
                        this.trainingId +
                        "/show"
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.assessmentShowArr = response.data;
                        this.showAssessmentTable = true;
                    });
            },
            // this will show trainee feedback which has been added
            showTraineeFeedback: function showTraineeFeedback() {
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/program-officer/training/trainee-feedback/" +
                        this.trainingId +
                        "/show"
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.traineeFeedbackShowArr = response.data;
                    });
            },
            // this will show trainer feedback which has been added
            showTrainerFeedback: function showTrainerFeedback() {
                this.openLoading();
                axios
                    .get(
                        process.env.VUE_APP_BASE_PATH +
                        "/program-officer/training/trainer-feedback/" +
                        this.trainingId +
                        "/show"
    
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.trainerFeedbackShowArr = response.data;
                    });
            },
            // step 3 functions
            adminCountry() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/countries/get")
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.countryArr = response.data;
                    });
            },
            //select all provinces
            adminProvince() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/provinces/get")
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.provinceArr = response.data;
                    });
            },
            //select all district
            adminDistricts() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.cityArr = response.data;
                    });
            },
            //select all department
            adminDepartment() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get")
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.departmentArr = response.data;
                    });
            },
            //select all training type
            adminTrainingType() {
                this.openLoading();
                axios
                    .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
    
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        this.trainingTypeArr = response.data;
                    });
            },
            // End of step 3
            openLoading() {
                this.$vs.loading({
                    type: "material"
                });
            },
            getReport() {
                downloadTrainingReport([this.trainingId])
            },
            closeLoading() {
                this.$vs.loading.close();
            },
            printReport: function () {
                window.print();
            },
            toastSuccess(msg) {
                this.$bvToast.toast(msg, {
                    title: "Success",
                    autoHideDelay: 10000,
                    variant: "success",
                    solid: true
                });
            },
            toastError(msg) {
                this.$bvToast.toast(msg, {
                    title: "Error",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true
                });
            },
           async getAttendance(tId) {
                this.openLoading();
                try{
                     const response = await axios.get(
                        process.env.VUE_APP_BASE_PATH + "/training/get-attendance/" + tId
                    )
                    this.closeLoading();
                    this.attendanceData = response.data;
                    this.itemsTrainee = response.data.traineeResponse;
                    this.itemsTrainer = response.data.trainerResponse;
                    this.trainingResponse = response.data.trainingResponse;
                }catch(error){
                    this.closeLoading();
                    this.$toasted.global.errorMsg('Error loading attendance data', error.response || error.message);
                }
                
            },
    
            downloadSheet() {
                this.openLoading(); // Show loading indicator
    
                // First load the attendance data
                axios.get(process.env.VUE_APP_BASE_PATH + "/training/get-attendance/" + this.trainingId)
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                            return;
                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                            return;
                        }
    
                        this.attendanceData = response.data;
                        this.itemsTrainee = response.data.traineeResponse;
                        this.itemsTrainer = response.data.trainerResponse;
                        this.trainingResponse = response.data.trainingResponse;
    
                        // Now generate the PDF
                        const element = document.getElementById("attendance-sheet");
                        if (!element) {
                            this.$toasted.global.errorMsg('Attendance sheet element not found');
                            this.closeLoading();
                            return;
                        }
    
                        // Show the hidden element
                        element.style.display = 'block';
    
                        // Wait for DOM to update and data to be rendered
                        this.$nextTick(() => {
                            const opt = {
                                margin: 0.5,
                                filename: `${this.trainingTitle} attendance-sheet.pdf`,
                                image: {
                                    type: 'jpeg',
                                    quality: 1.0
                                },
                                html2canvas: {
                                    scale: 4,
                                    useCORS: true,
                                    logging: true,
                                    letterRendering: true,
                                    allowTaint: true,
                                    dpi: 300,
                                    windowWidth: 1920
                                },
                                jsPDF: {
                                    unit: 'in',
                                    format: 'a4',
                                    orientation: 'landscape',
                                    compress: true
                                }
                            };
    
                            // Add a small delay to ensure all content is rendered
                            setTimeout(() => {
                                html2pdf()
                                    .set(opt)
                                    .from(element)
                                    .save()
                                    .then(() => {
                                        // Hide the element again after PDF generation
                                        element.style.display = 'none';
                                        this.closeLoading();
                                    })
                                    .catch(() => {
    
                                        this.$toasted.global.errorMsg('Error generating PDF');
                                        this.closeLoading();
                                    });
                            }, 500);
                        });
                    })
                    .catch(() => {
    
                        this.$toasted.global.errorMsg('Error loading attendance data');
                        this.closeLoading();
                    });
            },
            getDesignationTitle(designationId) {
                const match = this.designationArr?.find(
                    (item) => item.id == designationId
                );
                return match ? match.title : '';
            },
            printSheet: function () {
                const printContents = document.getElementById("attendance-sheet").innerHTML;
                const printWindow = window.open("", "_blank");
    
                printWindow.document.open();
                printWindow.document.write(`
                         <html>
        <head>
          <title>${this.trainingTitle} attendance-sheet.pdf</title>
    
    <style>
    /* General styling */
    body {
        font-family: Arial, sans-serif;
    }
    
    /* Table styling */
    table {
        width: 100%;
        border-collapse: collapse;
    }
    
    td,
    tr {
        border: 1px solid black;
        padding: 8px;
        text-align: left;
    }
    
    th {
        border: 1px solid black;
        padding: 8px;
        text-align: center;
        background-color: #f2f2f2;
    }
    
    /* Header section styling */
    .header {
        justify-content: space-between;
        align-items: center;
    }
    
    h3 {
        text-align: center;
        text-decoration: underline;
    }
    
    .header img {
        width: 200px;
        /* Adjust the size of the image */
    }
    
    /* Address section */
    .address {
        font-size: 14px;
        margin-top: 0px;
        text-align: left;
    }
    
    /* List name styling */
    .list_name {
        font-size: 18px;
    }
    </style>
        </head>
        <body onload="window.print()">
          ${printContents}
        </body>
      </html>
    
        `);
                printWindow.document.close();
    
            },
            openNominationModal() {
                this.showNominationModal = true;
            },
            closeNominationModal() {
                this.showNominationModal = false;
            }
        },
        
        components: {
            Selectize,
            flatPickr,
            TrainerView,
            TrainingAgenda,
            UploadMaterial,
            TrainingAssessment,
            TraineeRegistration,
            AssessmentReview,
            "app-navbar": Navbar,
            "app-sidebar": Sidebar
        },
        computed: {
            getTrainingData() {
                return this.updateTraining && this.updateTraining.training || {}
            },
    
            getProjectData() {
                return this.getTrainingData.project || {}
            },
    
            getSubprogramData() {
                return this.getTrainingData.subprogram || {}
            },
    
            getAdvisorData() {
                return this.getTrainingData.advisor || {}
            },
    
            // getAttendanceData() {
            //     return this.attendanceData && this.attendanceData.trainingResponse || {}
            // }
        }
    };
    </script>
    
        <style scoped>
        .vs-breadcrumb {
          font-size: 18px !important;
          font-weight: 600 !important;
        }
        .btn-primary {
          font-size: 14px;
          height: 36px;
          background: #06a6e0;
          color: #ffffff;
          font-weight: 500;
          border-radius: 5px
        }
        .white-text {
          color: #ffffff;
        }
        .btn-primary:hover {
          background: #08769e;
        }
        .btn-info{
           height: 50px;
          font-size: 14px;
          font-weight: 500;
          border-radius: 5px
        }
        #grad1 {
          background-color: #fff;
        }
    
        #msform {
          text-align: center;
          position: relative;
          margin-top: 20px;
        }
    
        #msform fieldset .form-card {
          background: white;
          border: 0 none;
          border-radius: 0px;
          box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
          padding: 20px 40px 30px 40px;
          box-sizing: border-box;
          width: 94%;
          margin: 0 3% 20px 3%;
          position: relative;
        }
    
        #msform fieldset {
          padding: 10px;
          background: #e8e8e8;
          border: 0 none;
          border-radius: 2rem;
          box-sizing: border-box;
          width: 100%;
          margin: 0;
          border: 2px solid #ccc;
          padding-bottom: 20px;
          position: relative;
        }
    
        #msform fieldset:not(:first-of-type) {
          display: none;
        }
    
        #msform fieldset .form-card {
          text-align: left;
          color: #9e9e9e;
        }
        #progressbar .completed {
          color: #06a6e0;
        }
    
        #progressbar li.completed:before,
        #progressbar li.completed:after {
          background: #06a6e0;
        }
    
        #msform .action-button {
          width: 100px;
          background: skyblue;
          font-weight: bold;
          color: white;
          border: 0 none;
          border-radius: 0px;
          cursor: pointer;
          padding: 10px 5px;
          margin: 10px 5px;
        }
    
        #msform .action-button:hover,
        #msform .action-button:focus {
          box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
        }
    
        #msform .action-button-previous {
          width: 100px;
          background: #616161;
          font-weight: bold;
          color: white;
          border: 0 none;
          border-radius: 0px;
          cursor: pointer;
          padding: 10px 5px;
          margin: 10px 5px;
        }
    
        #msform .action-button-previous:hover,
        #msform .action-button-previous:focus {
          box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
        }
    
        select.list-dt {
          border: none;
          outline: 0;
          border-bottom: 1px solid #ccc;
          padding: 2px 5px 3px 5px;
          margin: 2px;
        }
    
        select.list-dt:focus {
          border-bottom: 2px solid skyblue;
        }
    
        .card {
          z-index: 0;
          border: none;
          border-radius: 0.5rem;
          position: relative;
        }
    
        .fs-title {
          font-size: 25px;
          color: #2c3e50;
          margin-bottom: 10px;
          font-weight: bold;
          text-align: left;
        }
    
        #progressbar {
          margin-bottom: 30px;
          overflow: hidden;
          color: lightgrey;
        }
    
        #progressbar .active {
          color: #000000;
        }
    
        #progressbar li {
          list-style-type: none;
          font-size: 12px;
          width: 9.5%;
          text-align:center;
          float:left;
          position: relative;
        }
    
        #progressbar #NewTraining:before {
          content: "1";
        }
    
        #progressbar #PoAssignment:before {
          content: "2";
        }
    
        #progressbar #TrainingInformation:before {
          content: "3";
        }
        #progressbar #TrainerRegistration:before {
          content: "4a";
        }
    
        #progressbar #TrainingAgenda:before {
          content: "4b";
        }
    
        #progressbar #Trainingmaterial:before {
          content: "4c";
        }
        #progressbar #TrainingAssessments:before {
          content: "4d";
        }
    
        #progressbar #TraineeRegistration:before {
          content: "4e";
        }
    
        #progressbar #AssessmentReview:before {
          content: "5";
        }
    
        #progressbar #Completion:before {
          content: "6";
        }
    
        #progressbar li:before {
          width: 35px;
          height: 35px;
          line-height: 30px;
          display: block;
          font-size: 18px;
          color: #ffffff;
          background: lightgray;
          border-radius: 50%;
          margin: 0 auto 10px auto;
          padding: 2px;
        }
    
        #progressbar li:after {
          content: "";
          width: 100%;
          height: 2px;
          background: lightgray;
          position: absolute;
          left: 0;
          top: 17px;
          z-index: -1;
        }
    
        #progressbar li.active:before,
        #progressbar li.active:after {
          background: #000000;
        }
    
        .radio-group {
          position: relative;
          margin-bottom: 25px;
        }
    
        .radio {
          display: inline-block;
          width: 204;
          height: 104;
          border-radius: 0;
          background: lightblue;
          box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
          box-sizing: border-box;
          cursor: pointer;
          margin: 8px 2px;
        }
    
        .radio:hover {
          box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
        }
    
        .radio.selected {
          box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
        }
    
        .fit-image {
          width: 100%;
          object-fit: cover;
        }
    
        /*Sheet style */
          table {
                    width: 100%;
                    border-collapse: collapse;
                }
                th, td, tr {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: center;
                }
    
                th {
                    background-color: #f2f2f2;
                }
                .header {
                    /* display: flex; */
                    justify-content: space-between;
                    align-items: center;
    
                }
    
                h3 {
                    text-align: center;
                    text-decoration: underline;
                }
                .address {
                    font-size: 14px;
                    margin-top: 0px;
                    text-align: left;
                }
                .list_name{
                  font-size: 18px
                }
    
        /* Only show the attendance sheet when printing */
        @media print {
          #attendance-sheet {
            display: block;
            position: relative;
            width: 100%;
            page-break-before: always; /* Ensure the sheet starts on a new page */
          }
    
          /* Hide everything else during printing */
          body * {
            visibility: hidden;
          }
    
          #attendance-sheet, #attendance-sheet * {
            visibility: visible;
          }
    
          #attendance-sheet {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
    
        #attendance-sheet {
          display: none;
        }
    
        #attendance-sheet table {
          width: 100%;
          border-collapse: collapse;
        }
    
        #attendance-sheet th {
          border: 1px solid black;
          padding: 8px;
          text-align: center;
          background-color: #f2f2f2;
        }
    
        #attendance-sheet td {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
    
        /* Specific column alignments */
        #attendance-sheet td:first-child, /* Serial number column */
        #attendance-sheet td:nth-child(5) { /* Contact number column */
          text-align: center;
        }
    
        #attendance-sheet td:nth-child(2), /* Name column */
        #attendance-sheet td:nth-child(3), /* Organization column */
        #attendance-sheet td:nth-child(4) { /* Designation column */
          text-align: left;
        }
    
        /* Signature columns alignment */
        #attendance-sheet td:nth-child(n+6) {
          text-align: center;
          min-width: 100px;
        }
    
        #attendance-sheet .header {
          justify-content: space-between;
          align-items: center;
        }
    
        #attendance-sheet .address {
          font-size: 14px;
          margin-top: 0px;
          text-align: left;
        }
    
        #attendance-sheet .list_name {
          font-size: 18px;
        }
    
        @media print {
          #attendance-sheet {
            display: block;
            position: relative;
            width: 100%;
            page-break-before: always;
          }
    
          body * {
            visibility: hidden;
          }
    
          #attendance-sheet, #attendance-sheet * {
            visibility: visible;
          }
    
          #attendance-sheet {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
    
        /* Updated table styles for better vertical display */
        #attendance-sheet table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed; /* Added to control column widths */
        }
    
        #attendance-sheet th, 
        #attendance-sheet td {
            border: 1px solid black;
            padding: 8px;
            word-wrap: break-word; /* Allow text to wrap within cells */
        }
    
        #attendance-sheet th {
            background-color: #f2f2f2;
            font-weight: bold;
        }
    
        /* Set specific column widths */
        #attendance-sheet td:first-child { /* Serial number column */
            width: 5%;
            text-align: center;
        }
    
        #attendance-sheet td:nth-child(2) { /* Name column */
            width: 20%;
        }
    
        #attendance-sheet td:nth-child(3) { /* Organization column */
            width: 20%;
        }
    
        #attendance-sheet td:nth-child(4) { /* Designation column */
            width: 20%;
        }
    
        #attendance-sheet td:nth-child(5) { /* Contact number column */
            width: 15%;
            text-align: center;
        }
    
        /* Signature columns */
        #attendance-sheet td:nth-child(n+6) {
            width: 5%;
            text-align: center;
            min-width: 50px;
        }
    
        /* Ensure the table fits within the page width */
        #attendance-sheet {
            max-width: 100%;
            overflow-x: auto;
        }
    
        /* Header and logo styles */
        #attendance-sheet .header {
            text-align: center;
            margin-bottom: 20px;
        }
    
        #attendance-sheet .header img {
            width: 200px;
            margin-bottom: 10px;
        }
    
        #attendance-sheet .header h3 {
            margin: 10px 0;
            text-align: center;
            text-decoration: underline;
        }
    
        /* Print specific styles */
        @media print {
            #attendance-sheet {
                width: 100%;
                margin: 0;
                padding: 0;
            }
    
            #attendance-sheet table {
                page-break-inside: auto;
            }
    
            #attendance-sheet tr {
                page-break-inside: avoid;
                page-break-after: auto;
            }
        }
        .download-btn {
      background-color: #4285f4;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 6px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
    }
    
    .download-btn:hover {
      background-color: #3367d6;
      transform: translateY(-1px);
    }
    
    .download-btn i {
      margin-right: 6px;
      font-size: 18px;
    }
    
    .download-text {
      font-size: 0.85rem;
    }
    
        </style>
    